const routes = {
    '/': 'Index',
}

module.exports = routes